import $ from 'jquery';
import get from 'lodash/get';

export default function(){
  const openFilter = get(window, 'rcProps.trigger.plp.openFilter', false);
  if (openFilter === true || openFilter === 'true') {
    $('.js-amp-filter').click();
  }
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/amp-filters.js